<template>
    <div class="library-visible-to-filter" data-testid="library-visible-to-filter">
        <collapsible-widget>
            <template #name>Visible To</template>

            <RadioGroup v-model="creativeLibraryFiltersStore.visibleTo">
                <Radio v-for="{ label, value } in optionsWithMe" :key="value" :label="value">
                    {{ label }}
                </Radio>
            </RadioGroup>
        </collapsible-widget>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useStore } from "vuex";

import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import { UserActions } from "@/enums/user";
import { RolesGetter, type Role } from "@/store/modules/roles";
import { useCreativeLibraryFiltersStore } from "@/store/pinia/creativeLibraryFilters";
import type { RootState } from "@/store/types";

const creativeLibraryFiltersStore = useCreativeLibraryFiltersStore();
const store = useStore<RootState>();

const rolesThatCanOnlyViewDeliverablesVisibleToRole = computed(
    () => store.getters[RolesGetter.getRolesThatDoNotHaveAction](UserActions.CanChangeDeliverableVisibility) as Role[]
);

const options = computed(() =>
    rolesThatCanOnlyViewDeliverablesVisibleToRole.value.map(role => ({
        label: role.name,
        value: role._id
    }))
);

const optionsWithMe = computed(() => [{ label: "Me", value: "ME" }, ...options.value]);
</script>

<style lang="scss">
@use "@style/variables" as *;

.library-visible-to-filter {
    .ivu-radio {
        margin: 0;
    }

    .ivu-radio-group {
        display: block;
    }

    .ivu-radio-wrapper {
        margin: 0;
        padding: 0 0 0 50px;
        display: block;
    }
}
</style>
